const transformSearchParams = (
  searchParams: URLSearchParams
): Record<string, string> =>
  [...searchParams.entries()].reduce(
    (a, v) => ({ ...a, [v[0]]: v[1] }),
    {} as Record<string, string>
  )

export default transformSearchParams
